import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import globalUserProfile from '../../../../stores/global-user-profile';
import { StudentProfile } from '../../../../api/types/settings/settings-all';
import { UserPaymentServiceWithPriceList } from '../../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';
import { CreditCardPaymentDialog } from './components/credit-card-payment-dialog';

export const MyPayments = observer(() => {
  // State for payment dialog
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [selectedService, setSelectedService] =
    useState<UserPaymentServiceWithPriceList | null>(null);

  // Check if user profile exists and is a student
  if (!globalUserProfile.userProfile?.profile) {
    return <div>Loading user profile...</div>;
  }

  const studentProfile = globalUserProfile.userProfile
    .profile as StudentProfile;
  const paymentServices: UserPaymentServiceWithPriceList[] =
    studentProfile.paymentServiceDetails;
  const userId = globalUserProfile.userProfile.userWithRole.id;

  if (!paymentServices || paymentServices.length === 0) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>שירותי התשלום שלי</h2>
        <p>לא נמצאו שירותי תשלום רשומים</p>
      </div>
    );
  }

  // Payment handler
  const handlePaymentClick = (service: UserPaymentServiceWithPriceList) => {
    setSelectedService(service);
    setShowPaymentDialog(true);
  };

  return (
    <div>
      <CreditCardPaymentDialog
        visible={showPaymentDialog}
        onHide={() => setShowPaymentDialog(false)}
        selectedService={selectedService}
        userId={userId}
      />

      <h2>שירותי התשלום שלי</h2>
      <DataTable
        value={paymentServices}
        stripedRows
        showGridlines
        tableStyle={{ minWidth: '50rem' }}
        rows={10}
        style={{ marginTop: '16px' }}
      >
        <Column
          field="paymentService.paymentServiceName"
          header="שירות תשלום"
          style={{ textAlign: 'right', fontWeight: 'bold' }}
        />
        <Column
          field="allocations.programEntity.programName"
          header="תוכנית לימודים"
          style={{ textAlign: 'right' }}
        />
        <Column
          field="allocations.branch.branchName"
          header="שלוחה"
          style={{ textAlign: 'right' }}
        />
        <Column
          header="מחיר נוכחי"
          body={(rowData: UserPaymentServiceWithPriceList) => (
            <div>₪{rowData.currentPrices.price.toLocaleString('he-IL')}</div>
          )}
          style={{ textAlign: 'right' }}
        />
        <Column
          header="שולם"
          body={(rowData: UserPaymentServiceWithPriceList) => {
            const totalPaid =
              rowData.allocations.userPayments?.reduce(
                (sum, payment) => sum + payment.paymentAmount,
                0,
              ) ?? 0;
            return <div>₪{totalPaid.toLocaleString('he-IL')}</div>;
          }}
          style={{ textAlign: 'right' }}
        />
        <Column
          header="סטטוס"
          body={(rowData: UserPaymentServiceWithPriceList) => {
            const totalPaid =
              rowData.allocations.userPayments?.reduce(
                (sum, payment) => sum + payment.paymentAmount,
                0,
              ) ?? 0;
            const isPaid = totalPaid >= rowData.currentPrices.price;
            return (
              <Tag
                value={isPaid ? 'שולם' : 'ממתין לתשלום'}
                severity={isPaid ? 'success' : 'warning'}
              />
            );
          }}
          style={{ textAlign: 'right' }}
        />
        <Column
          header="פעולות"
          body={(rowData: UserPaymentServiceWithPriceList) => {
            const totalPaid =
              rowData.allocations.userPayments?.reduce(
                (sum, payment) => sum + payment.paymentAmount,
                0,
              ) ?? 0;
            const isPaid = totalPaid >= rowData.currentPrices.price;

            return (
              <Button
                label="תשלום"
                icon="pi pi-credit-card"
                onClick={() => handlePaymentClick(rowData)}
                disabled={isPaid}
                style={{
                  height: '30px',
                  fontSize: '14px',
                }}
              />
            );
          }}
          style={{ textAlign: 'center' }}
        />
      </DataTable>
    </div>
  );
});
